export default class SessionClosedViewModel {
  public SessionId?: string;
  public Reason?: number;
  public DisplayValue?: string;
}
